module.exports = __webpack_public_path__ + "fonts/a6ff1LnT.woff2";